/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable jsx-a11y/anchor-is-valid */
import classname from 'classnames';
import { useNavbarContext } from 'contexts/NavbarContext';
import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router';
import { Link } from 'react-router-dom';

const NavItemLink = ({ path, title, tabName, productos = [] }) => {
  const location = useLocation();

  const [selected, setSelected] = useState(false);

  const { productoActivo, setProductoActivo } = useNavbarContext();

  useEffect(() => {
    setSelected(false);
    if (location.pathname === path) {
      setSelected(true);
      setProductoActivo(null);
    } else {
      if (productoActivo && productoActivo !== '') {
        setSelected(productos.includes(productoActivo));
      }
    }
  }, [location, productoActivo]);

  return (
    <li
      className={classname({
        cpointer: true,
        nav__item: true,
        selected: selected,
      })}
    >
      <Link to={path} style={{ padding: '25px 35px' }}>
        {title}
      </Link>
    </li>
  );
};

export default NavItemLink;
